import { DecorationTagButton } from './decoration-tag-button';

export const MentionButton = () => {
	return <DecorationTagButton tag="mention" />;
};
